// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as ModalBody from "../../../../library/reuseable-components/ModalBody.bs.js";
import * as Belt_Array from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as Caml_format from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as ModalFooter from "../../../../library/reuseable-components/ModalFooter.bs.js";
import * as Row$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as CorePricingContext from "../../../../library/core-pricing-context/CorePricingContext.bs.js";
import * as FormInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as LabelUnit$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/label-unit/LabelUnit.bs.js";
import * as Timestamp$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as ModificationFormHelper from "../common/ModificationFormHelper.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as FomDateInputTs$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/FomDateInputTs.bs.js";
import * as CampaignModificationType from "../../../../../../app/pricing-modifications/entity/CampaignModificationType.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";
import * as SelectComponent$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/drop-downs/SelectComponent.bs.js";
import * as PrimitiveFormTypes$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/PrimitiveFormTypes.bs.js";

function AbModificationKeyDetailsForm$TestIdRangeInput(Props) {
  var startId = Props.startId;
  var endId = Props.endId;
  var label = Props.label;
  var changeStartId = Props.changeStartId;
  var changeEndId = Props.changeEndId;
  var result1 = Props.result1;
  var result2 = Props.result2;
  var value = ModificationFormHelper.getPercentage(endId, startId);
  var tmp;
  if (result1 !== undefined) {
    if (result2 !== undefined) {
      if (result1.TAG === /* Ok */0) {
        tmp = result2.TAG === /* Ok */0 ? null : result2._0;
      } else {
        var err1 = result1._0;
        tmp = err1;
      }
    } else {
      tmp = result1.TAG === /* Ok */0 ? null : result1._0;
    }
  } else {
    tmp = result2 !== undefined ? (
        result2.TAG === /* Ok */0 ? null : result2._0
      ) : React.createElement("label", {
            className: "helper-text"
          }, "Test ID's cannot be less than 0 or greater than 99");
  }
  return React.createElement(Row$Catalyst.make, {
              children: null,
              className: "c-modification-key-detail-input"
            }, label, React.createElement("div", {
                  className: "input-error-section"
                }, React.createElement(Row$Catalyst.make, {
                      children: null,
                      className: "input-section"
                    }, React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  return Curry._1(changeStartId, FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: Belt_Option.getWithDefault(startId, "")
                          }
                        }), React.createElement("label", undefined, " - "), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  return Curry._1(changeEndId, FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: Belt_Option.getWithDefault(endId, "")
                          }
                        }), React.createElement("div", {
                          className: "value-box " + (
                            value === "Invalid" ? " negative" : " positive"
                          )
                        }, value)), React.createElement("div", {
                      className: "error-container"
                    }, tmp)));
}

var TestIdRangeInput = {
  make: AbModificationKeyDetailsForm$TestIdRangeInput
};

var validators_test_4_end = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var test_group = param.test_group;
      if (test_group !== undefined && Caml_format.caml_int_of_string(test_group.value) >= 4) {
        return ModificationFormHelper.endIdValidator(param.test_4_start, param.test_4_end);
      } else {
        return {
                TAG: /* Ok */0,
                _0: ""
              };
      }
    })
};

var validators_test_4_start = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var test_group = param.test_group;
      if (test_group !== undefined && Caml_format.caml_int_of_string(test_group.value) >= 4) {
        return ModificationFormHelper.startIdValidator(param.test_4_start);
      } else {
        return {
                TAG: /* Ok */0,
                _0: ""
              };
      }
    })
};

var validators_test_3_end = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var test_group = param.test_group;
      if (test_group !== undefined && Caml_format.caml_int_of_string(test_group.value) >= 3) {
        return ModificationFormHelper.endIdValidator(param.test_3_start, param.test_3_end);
      } else {
        return {
                TAG: /* Ok */0,
                _0: ""
              };
      }
    })
};

var validators_test_3_start = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var test_group = param.test_group;
      if (test_group !== undefined && Caml_format.caml_int_of_string(test_group.value) >= 3) {
        return ModificationFormHelper.startIdValidator(param.test_3_start);
      } else {
        return {
                TAG: /* Ok */0,
                _0: ""
              };
      }
    })
};

var validators_test_2_end = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var test_group = param.test_group;
      if (test_group !== undefined && Caml_format.caml_int_of_string(test_group.value) >= 2) {
        return ModificationFormHelper.endIdValidator(param.test_2_start, param.test_2_end);
      } else {
        return {
                TAG: /* Ok */0,
                _0: ""
              };
      }
    })
};

var validators_test_2_start = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var test_group = param.test_group;
      if (test_group !== undefined && Caml_format.caml_int_of_string(test_group.value) >= 2) {
        return ModificationFormHelper.startIdValidator(param.test_2_start);
      } else {
        return {
                TAG: /* Ok */0,
                _0: ""
              };
      }
    })
};

var validators_test_1_end = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var test_group = param.test_group;
      if (test_group !== undefined && Caml_format.caml_int_of_string(test_group.value) >= 1) {
        return ModificationFormHelper.endIdValidator(param.test_1_start, param.test_1_end);
      } else {
        return {
                TAG: /* Ok */0,
                _0: ""
              };
      }
    })
};

var validators_test_1_start = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var test_group = param.test_group;
      if (test_group !== undefined && Caml_format.caml_int_of_string(test_group.value) >= 1) {
        return ModificationFormHelper.startIdValidator(param.test_1_start);
      } else {
        return {
                TAG: /* Ok */0,
                _0: ""
              };
      }
    })
};

var validators_test_group = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var test_group = param.test_group;
      if (test_group === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Please select test group"
              };
      }
      var list_of_ids = ModificationFormHelper.generateList(Caml_format.caml_int_of_string(test_group.value), param.test_1_start, param.test_1_end, param.test_2_start, param.test_2_end, param.test_3_start, param.test_3_end, param.test_4_start, param.test_4_end);
      if (ModificationFormHelper.checkForOverlap(list_of_ids)) {
        return {
                TAG: /* Error */1,
                _0: "Test group IDs are overlapping, please enter correct values"
              };
      } else if (ModificationFormHelper.validIdRangeSum(list_of_ids)) {
        return {
                TAG: /* Ok */0,
                _0: test_group.value
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Sum of test group ID's should be less than 100%"
              };
      }
    })
};

var validators_end_date = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var end_date = param.end_date;
      var start_date = param.start_date;
      if (start_date === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Please select a start date first"
              };
      }
      if (end_date === undefined) {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
      var end_date$1 = Caml_option.valFromOption(end_date);
      var start_date$1 = Caml_option.valFromOption(start_date);
      var isEndDateBeforeStartDate = Timestamp$Catalyst.isBefore(end_date$1, start_date$1);
      if (isEndDateBeforeStartDate) {
        return {
                TAG: /* Error */1,
                _0: "End date cannot be before start date"
              };
      }
      if (param.modification_type) {
        return {
                TAG: /* Ok */0,
                _0: Caml_option.some(end_date$1)
              };
      }
      var maxAllowedDate = Timestamp$Catalyst.getDateTimeAfterElapsedTime(4.0, /* Months */2, start_date$1);
      var match = Timestamp$Catalyst.isAfter(end_date$1, maxAllowedDate);
      if (match) {
        return {
                TAG: /* Error */1,
                _0: "Experiment duration cannot be more than 4 months"
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: Caml_option.some(end_date$1)
              };
      }
    })
};

var validators_start_date = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      var start_date = param.start_date;
      if (start_date !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: Caml_option.valFromOption(start_date)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Start date is required"
              };
      }
    })
};

var validators_modification_name = {
  strategy: /* OnFirstChange */1,
  validate: (function (param) {
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* String */1,
                      _0: param.modification_name
                    }), (function (name) {
                    if (name.length > 60) {
                      return {
                              TAG: /* Error */1,
                              _0: "Modification Name cannot be more than 60 characters"
                            };
                    } else if (name.length < 3) {
                      return {
                              TAG: /* Error */1,
                              _0: "Modification Name cannot be less than 3 characters"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: name
                            };
                    }
                  }));
    })
};

var validators = {
  test_4_end: validators_test_4_end,
  test_4_start: validators_test_4_start,
  test_3_end: validators_test_3_end,
  test_3_start: validators_test_3_start,
  test_2_end: validators_test_2_end,
  test_2_start: validators_test_2_start,
  test_1_end: validators_test_1_end,
  test_1_start: validators_test_1_start,
  test_group: validators_test_group,
  end_date: validators_end_date,
  start_date: validators_start_date,
  modification_name: validators_modification_name,
  modification_type: undefined,
  vehicle: undefined,
  region: undefined
};

function initialFieldsStatuses(_input) {
  return {
          test_4_end: /* Pristine */0,
          test_4_start: /* Pristine */0,
          test_3_end: /* Pristine */0,
          test_3_start: /* Pristine */0,
          test_2_end: /* Pristine */0,
          test_2_start: /* Pristine */0,
          test_1_end: /* Pristine */0,
          test_1_start: /* Pristine */0,
          test_group: /* Pristine */0,
          end_date: /* Pristine */0,
          start_date: /* Pristine */0,
          modification_name: /* Pristine */0,
          modification_type: /* Pristine */0,
          vehicle: /* Pristine */0,
          region: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.test_4_end;
  var match_0 = match ? match._0 : Curry._1(validators.test_4_end.validate, input);
  var match$1 = fieldsStatuses.test_4_start;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.test_4_start.validate, input);
  var match$2 = fieldsStatuses.test_3_end;
  var match_0$2 = match$2 ? match$2._0 : Curry._1(validators.test_3_end.validate, input);
  var match$3 = fieldsStatuses.test_3_start;
  var match_0$3 = match$3 ? match$3._0 : Curry._1(validators.test_3_start.validate, input);
  var match$4 = fieldsStatuses.test_2_end;
  var match_0$4 = match$4 ? match$4._0 : Curry._1(validators.test_2_end.validate, input);
  var match$5 = fieldsStatuses.test_2_start;
  var match_0$5 = match$5 ? match$5._0 : Curry._1(validators.test_2_start.validate, input);
  var match$6 = fieldsStatuses.test_1_end;
  var match_0$6 = match$6 ? match$6._0 : Curry._1(validators.test_1_end.validate, input);
  var match$7 = fieldsStatuses.test_1_start;
  var match_0$7 = match$7 ? match$7._0 : Curry._1(validators.test_1_start.validate, input);
  var match$8 = fieldsStatuses.test_group;
  var match_0$8 = match$8 ? match$8._0 : Curry._1(validators.test_group.validate, input);
  var match$9 = fieldsStatuses.end_date;
  var match_0$9 = match$9 ? match$9._0 : Curry._1(validators.end_date.validate, input);
  var match$10 = fieldsStatuses.start_date;
  var match_0$10 = match$10 ? match$10._0 : Curry._1(validators.start_date.validate, input);
  var match$11 = fieldsStatuses.modification_name;
  var match_0$11 = match$11 ? match$11._0 : Curry._1(validators.modification_name.validate, input);
  var match_0$12 = {
    TAG: /* Ok */0,
    _0: input.modification_type
  };
  var match_0$13 = {
    TAG: /* Ok */0,
    _0: input.vehicle
  };
  var match_0$14 = {
    TAG: /* Ok */0,
    _0: input.region
  };
  var test_4_endResult = match_0;
  var test_4_endResult$1;
  if (test_4_endResult.TAG === /* Ok */0) {
    var test_4_startResult = match_0$1;
    if (test_4_startResult.TAG === /* Ok */0) {
      var test_3_endResult = match_0$2;
      if (test_3_endResult.TAG === /* Ok */0) {
        var test_3_startResult = match_0$3;
        if (test_3_startResult.TAG === /* Ok */0) {
          var test_2_endResult = match_0$4;
          if (test_2_endResult.TAG === /* Ok */0) {
            var test_2_startResult = match_0$5;
            if (test_2_startResult.TAG === /* Ok */0) {
              var test_1_endResult = match_0$6;
              if (test_1_endResult.TAG === /* Ok */0) {
                var test_1_startResult = match_0$7;
                if (test_1_startResult.TAG === /* Ok */0) {
                  var test_groupResult = match_0$8;
                  if (test_groupResult.TAG === /* Ok */0) {
                    var end_dateResult = match_0$9;
                    if (end_dateResult.TAG === /* Ok */0) {
                      var start_dateResult = match_0$10;
                      if (start_dateResult.TAG === /* Ok */0) {
                        var modification_nameResult = match_0$11;
                        if (modification_nameResult.TAG === /* Ok */0) {
                          var modification_typeResult = match_0$12;
                          if (modification_typeResult.TAG === /* Ok */0) {
                            var vehicleResult = match_0$13;
                            if (vehicleResult.TAG === /* Ok */0) {
                              var regionResult = match_0$14;
                              if (regionResult.TAG === /* Ok */0) {
                                return {
                                        TAG: /* Valid */0,
                                        output: {
                                          region: regionResult._0,
                                          vehicle: vehicleResult._0,
                                          modification_type: modification_typeResult._0,
                                          modification_name: modification_nameResult._0,
                                          start_date: start_dateResult._0,
                                          end_date: end_dateResult._0,
                                          test_group: test_groupResult._0,
                                          test_1_start: test_1_startResult._0,
                                          test_1_end: test_1_endResult._0,
                                          test_2_start: test_2_startResult._0,
                                          test_2_end: test_2_endResult._0,
                                          test_3_start: test_3_startResult._0,
                                          test_3_end: test_3_endResult._0,
                                          test_4_start: test_4_startResult._0,
                                          test_4_end: test_4_endResult._0
                                        },
                                        fieldsStatuses: {
                                          test_4_end: /* Dirty */{
                                            _0: test_4_endResult,
                                            _1: /* Shown */0
                                          },
                                          test_4_start: /* Dirty */{
                                            _0: test_4_startResult,
                                            _1: /* Shown */0
                                          },
                                          test_3_end: /* Dirty */{
                                            _0: test_3_endResult,
                                            _1: /* Shown */0
                                          },
                                          test_3_start: /* Dirty */{
                                            _0: test_3_startResult,
                                            _1: /* Shown */0
                                          },
                                          test_2_end: /* Dirty */{
                                            _0: test_2_endResult,
                                            _1: /* Shown */0
                                          },
                                          test_2_start: /* Dirty */{
                                            _0: test_2_startResult,
                                            _1: /* Shown */0
                                          },
                                          test_1_end: /* Dirty */{
                                            _0: test_1_endResult,
                                            _1: /* Shown */0
                                          },
                                          test_1_start: /* Dirty */{
                                            _0: test_1_startResult,
                                            _1: /* Shown */0
                                          },
                                          test_group: /* Dirty */{
                                            _0: test_groupResult,
                                            _1: /* Shown */0
                                          },
                                          end_date: /* Dirty */{
                                            _0: end_dateResult,
                                            _1: /* Shown */0
                                          },
                                          start_date: /* Dirty */{
                                            _0: start_dateResult,
                                            _1: /* Shown */0
                                          },
                                          modification_name: /* Dirty */{
                                            _0: modification_nameResult,
                                            _1: /* Shown */0
                                          },
                                          modification_type: /* Dirty */{
                                            _0: modification_typeResult,
                                            _1: /* Hidden */1
                                          },
                                          vehicle: /* Dirty */{
                                            _0: vehicleResult,
                                            _1: /* Hidden */1
                                          },
                                          region: /* Dirty */{
                                            _0: regionResult,
                                            _1: /* Hidden */1
                                          }
                                        },
                                        collectionsStatuses: undefined
                                      };
                              }
                              test_4_endResult$1 = test_4_endResult;
                            } else {
                              test_4_endResult$1 = test_4_endResult;
                            }
                          } else {
                            test_4_endResult$1 = test_4_endResult;
                          }
                        } else {
                          test_4_endResult$1 = test_4_endResult;
                        }
                      } else {
                        test_4_endResult$1 = test_4_endResult;
                      }
                    } else {
                      test_4_endResult$1 = test_4_endResult;
                    }
                  } else {
                    test_4_endResult$1 = test_4_endResult;
                  }
                } else {
                  test_4_endResult$1 = test_4_endResult;
                }
              } else {
                test_4_endResult$1 = test_4_endResult;
              }
            } else {
              test_4_endResult$1 = test_4_endResult;
            }
          } else {
            test_4_endResult$1 = test_4_endResult;
          }
        } else {
          test_4_endResult$1 = test_4_endResult;
        }
      } else {
        test_4_endResult$1 = test_4_endResult;
      }
    } else {
      test_4_endResult$1 = test_4_endResult;
    }
  } else {
    test_4_endResult$1 = test_4_endResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            test_4_end: /* Dirty */{
              _0: test_4_endResult$1,
              _1: /* Shown */0
            },
            test_4_start: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            test_3_end: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            test_3_start: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            },
            test_2_end: /* Dirty */{
              _0: match_0$4,
              _1: /* Shown */0
            },
            test_2_start: /* Dirty */{
              _0: match_0$5,
              _1: /* Shown */0
            },
            test_1_end: /* Dirty */{
              _0: match_0$6,
              _1: /* Shown */0
            },
            test_1_start: /* Dirty */{
              _0: match_0$7,
              _1: /* Shown */0
            },
            test_group: /* Dirty */{
              _0: match_0$8,
              _1: /* Shown */0
            },
            end_date: /* Dirty */{
              _0: match_0$9,
              _1: /* Shown */0
            },
            start_date: /* Dirty */{
              _0: match_0$10,
              _1: /* Shown */0
            },
            modification_name: /* Dirty */{
              _0: match_0$11,
              _1: /* Shown */0
            },
            modification_type: /* Dirty */{
              _0: match_0$12,
              _1: /* Hidden */1
            },
            vehicle: /* Dirty */{
              _0: match_0$13,
              _1: /* Hidden */1
            },
            region: /* Dirty */{
              _0: match_0$14,
              _1: /* Hidden */1
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurTest_4_endField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.test_4_end, validators_test_4_end, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  test_4_end: status,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurTest_4_startField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.test_4_start, validators_test_4_start, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: status,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurTest_3_endField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.test_3_end, validators_test_3_end, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: status,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurTest_3_startField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.test_3_start, validators_test_3_start, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: status,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurTest_2_endField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.test_2_end, validators_test_2_end, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: status,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurTest_2_startField */5 :
                  var result$5 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.test_2_start, validators_test_2_start, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: status,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurTest_1_endField */6 :
                  var result$6 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.test_1_end, validators_test_1_end, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: status,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$6 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$6,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurTest_1_startField */7 :
                  var result$7 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.test_1_start, validators_test_1_start, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: status,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$7 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$7,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurTest_groupField */8 :
                  var result$8 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.test_group, validators_test_group, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: status,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$8 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$8,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurEnd_dateField */9 :
                  var result$9 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.end_date, validators_end_date, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: status,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$9 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$9,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurStart_dateField */10 :
                  var result$10 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.start_date, validators_start_date, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: status,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$10 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$10,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurModification_nameField */11 :
                  var result$11 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.modification_name, validators_modification_name, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: status,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$11 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$11,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurModification_typeField */12 :
                  var result$12 = Formality.validateFieldOnBlurWithoutValidator(state.input.modification_type, state.fieldsStatuses.modification_type, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: status,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$12 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$12,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurVehicleField */13 :
                  var result$13 = Formality.validateFieldOnBlurWithoutValidator(state.input.vehicle, state.fieldsStatuses.vehicle, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: status,
                                  region: init.region
                                };
                        }));
                  if (result$13 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$13,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurRegionField */14 :
                  var result$14 = Formality.validateFieldOnBlurWithoutValidator(state.input.region, state.fieldsStatuses.region, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: status
                                };
                        }));
                  if (result$14 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$14,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */15 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */15,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */16,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */18);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */17);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */16 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */17 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */18 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateTest_4_endField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  var nextFieldsStatuses = {
                    contents: state.fieldsStatuses
                  };
                  var result$15 = Formality.validateDependentFieldOnChange(nextInput, nextFieldsStatuses.contents.test_4_start, validators_test_4_start, (function (status) {
                          var init = nextFieldsStatuses.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: status,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$15 !== undefined) {
                    nextFieldsStatuses.contents = result$15;
                  }
                  var result$16 = Formality.validateDependentFieldOnChange(nextInput, nextFieldsStatuses.contents.test_group, validators_test_group, (function (status) {
                          var init = nextFieldsStatuses.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: status,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$16 !== undefined) {
                    nextFieldsStatuses.contents = result$16;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, nextFieldsStatuses.contents.test_4_end, state.submissionStatus, validators_test_4_end, (function (status) {
                                    var init = nextFieldsStatuses.contents;
                                    return {
                                            test_4_end: status,
                                            test_4_start: init.test_4_start,
                                            test_3_end: init.test_3_end,
                                            test_3_start: init.test_3_start,
                                            test_2_end: init.test_2_end,
                                            test_2_start: init.test_2_start,
                                            test_1_end: init.test_1_end,
                                            test_1_start: init.test_1_start,
                                            test_group: init.test_group,
                                            end_date: init.end_date,
                                            start_date: init.start_date,
                                            modification_name: init.modification_name,
                                            modification_type: init.modification_type,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateTest_4_startField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$1 = {
                    contents: state.fieldsStatuses
                  };
                  var result$17 = Formality.validateDependentFieldOnChange(nextInput$1, nextFieldsStatuses$1.contents.test_4_end, validators_test_4_end, (function (status) {
                          var init = nextFieldsStatuses$1.contents;
                          return {
                                  test_4_end: status,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$17 !== undefined) {
                    nextFieldsStatuses$1.contents = result$17;
                  }
                  var result$18 = Formality.validateDependentFieldOnChange(nextInput$1, nextFieldsStatuses$1.contents.test_group, validators_test_group, (function (status) {
                          var init = nextFieldsStatuses$1.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: status,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$18 !== undefined) {
                    nextFieldsStatuses$1.contents = result$18;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, nextFieldsStatuses$1.contents.test_4_start, state.submissionStatus, validators_test_4_start, (function (status) {
                                    var init = nextFieldsStatuses$1.contents;
                                    return {
                                            test_4_end: init.test_4_end,
                                            test_4_start: status,
                                            test_3_end: init.test_3_end,
                                            test_3_start: init.test_3_start,
                                            test_2_end: init.test_2_end,
                                            test_2_start: init.test_2_start,
                                            test_1_end: init.test_1_end,
                                            test_1_start: init.test_1_start,
                                            test_group: init.test_group,
                                            end_date: init.end_date,
                                            start_date: init.start_date,
                                            modification_name: init.modification_name,
                                            modification_type: init.modification_type,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateTest_3_endField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$2 = {
                    contents: state.fieldsStatuses
                  };
                  var result$19 = Formality.validateDependentFieldOnChange(nextInput$2, nextFieldsStatuses$2.contents.test_3_start, validators_test_3_start, (function (status) {
                          var init = nextFieldsStatuses$2.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: status,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$19 !== undefined) {
                    nextFieldsStatuses$2.contents = result$19;
                  }
                  var result$20 = Formality.validateDependentFieldOnChange(nextInput$2, nextFieldsStatuses$2.contents.test_group, validators_test_group, (function (status) {
                          var init = nextFieldsStatuses$2.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: status,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$20 !== undefined) {
                    nextFieldsStatuses$2.contents = result$20;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, nextFieldsStatuses$2.contents.test_3_end, state.submissionStatus, validators_test_3_end, (function (status) {
                                    var init = nextFieldsStatuses$2.contents;
                                    return {
                                            test_4_end: init.test_4_end,
                                            test_4_start: init.test_4_start,
                                            test_3_end: status,
                                            test_3_start: init.test_3_start,
                                            test_2_end: init.test_2_end,
                                            test_2_start: init.test_2_start,
                                            test_1_end: init.test_1_end,
                                            test_1_start: init.test_1_start,
                                            test_group: init.test_group,
                                            end_date: init.end_date,
                                            start_date: init.start_date,
                                            modification_name: init.modification_name,
                                            modification_type: init.modification_type,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateTest_3_startField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$3 = {
                    contents: state.fieldsStatuses
                  };
                  var result$21 = Formality.validateDependentFieldOnChange(nextInput$3, nextFieldsStatuses$3.contents.test_3_end, validators_test_3_end, (function (status) {
                          var init = nextFieldsStatuses$3.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: status,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$21 !== undefined) {
                    nextFieldsStatuses$3.contents = result$21;
                  }
                  var result$22 = Formality.validateDependentFieldOnChange(nextInput$3, nextFieldsStatuses$3.contents.test_group, validators_test_group, (function (status) {
                          var init = nextFieldsStatuses$3.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: status,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$22 !== undefined) {
                    nextFieldsStatuses$3.contents = result$22;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, nextFieldsStatuses$3.contents.test_3_start, state.submissionStatus, validators_test_3_start, (function (status) {
                                    var init = nextFieldsStatuses$3.contents;
                                    return {
                                            test_4_end: init.test_4_end,
                                            test_4_start: init.test_4_start,
                                            test_3_end: init.test_3_end,
                                            test_3_start: status,
                                            test_2_end: init.test_2_end,
                                            test_2_start: init.test_2_start,
                                            test_1_end: init.test_1_end,
                                            test_1_start: init.test_1_start,
                                            test_group: init.test_group,
                                            end_date: init.end_date,
                                            start_date: init.start_date,
                                            modification_name: init.modification_name,
                                            modification_type: init.modification_type,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateTest_2_endField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$4 = {
                    contents: state.fieldsStatuses
                  };
                  var result$23 = Formality.validateDependentFieldOnChange(nextInput$4, nextFieldsStatuses$4.contents.test_2_start, validators_test_2_start, (function (status) {
                          var init = nextFieldsStatuses$4.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: status,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$23 !== undefined) {
                    nextFieldsStatuses$4.contents = result$23;
                  }
                  var result$24 = Formality.validateDependentFieldOnChange(nextInput$4, nextFieldsStatuses$4.contents.test_group, validators_test_group, (function (status) {
                          var init = nextFieldsStatuses$4.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: status,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$24 !== undefined) {
                    nextFieldsStatuses$4.contents = result$24;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$4, nextFieldsStatuses$4.contents.test_2_end, state.submissionStatus, validators_test_2_end, (function (status) {
                                    var init = nextFieldsStatuses$4.contents;
                                    return {
                                            test_4_end: init.test_4_end,
                                            test_4_start: init.test_4_start,
                                            test_3_end: init.test_3_end,
                                            test_3_start: init.test_3_start,
                                            test_2_end: status,
                                            test_2_start: init.test_2_start,
                                            test_1_end: init.test_1_end,
                                            test_1_start: init.test_1_start,
                                            test_group: init.test_group,
                                            end_date: init.end_date,
                                            start_date: init.start_date,
                                            modification_name: init.modification_name,
                                            modification_type: init.modification_type,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateTest_2_startField */5 :
                  var nextInput$5 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$5 = {
                    contents: state.fieldsStatuses
                  };
                  var result$25 = Formality.validateDependentFieldOnChange(nextInput$5, nextFieldsStatuses$5.contents.test_2_end, validators_test_2_end, (function (status) {
                          var init = nextFieldsStatuses$5.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: status,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$25 !== undefined) {
                    nextFieldsStatuses$5.contents = result$25;
                  }
                  var result$26 = Formality.validateDependentFieldOnChange(nextInput$5, nextFieldsStatuses$5.contents.test_group, validators_test_group, (function (status) {
                          var init = nextFieldsStatuses$5.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: status,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$26 !== undefined) {
                    nextFieldsStatuses$5.contents = result$26;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$5, nextFieldsStatuses$5.contents.test_2_start, state.submissionStatus, validators_test_2_start, (function (status) {
                                    var init = nextFieldsStatuses$5.contents;
                                    return {
                                            test_4_end: init.test_4_end,
                                            test_4_start: init.test_4_start,
                                            test_3_end: init.test_3_end,
                                            test_3_start: init.test_3_start,
                                            test_2_end: init.test_2_end,
                                            test_2_start: status,
                                            test_1_end: init.test_1_end,
                                            test_1_start: init.test_1_start,
                                            test_group: init.test_group,
                                            end_date: init.end_date,
                                            start_date: init.start_date,
                                            modification_name: init.modification_name,
                                            modification_type: init.modification_type,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateTest_1_endField */6 :
                  var nextInput$6 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$6 = {
                    contents: state.fieldsStatuses
                  };
                  var result$27 = Formality.validateDependentFieldOnChange(nextInput$6, nextFieldsStatuses$6.contents.test_1_start, validators_test_1_start, (function (status) {
                          var init = nextFieldsStatuses$6.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: status,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$27 !== undefined) {
                    nextFieldsStatuses$6.contents = result$27;
                  }
                  var result$28 = Formality.validateDependentFieldOnChange(nextInput$6, nextFieldsStatuses$6.contents.test_group, validators_test_group, (function (status) {
                          var init = nextFieldsStatuses$6.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: status,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$28 !== undefined) {
                    nextFieldsStatuses$6.contents = result$28;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$6,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$6, nextFieldsStatuses$6.contents.test_1_end, state.submissionStatus, validators_test_1_end, (function (status) {
                                    var init = nextFieldsStatuses$6.contents;
                                    return {
                                            test_4_end: init.test_4_end,
                                            test_4_start: init.test_4_start,
                                            test_3_end: init.test_3_end,
                                            test_3_start: init.test_3_start,
                                            test_2_end: init.test_2_end,
                                            test_2_start: init.test_2_start,
                                            test_1_end: status,
                                            test_1_start: init.test_1_start,
                                            test_group: init.test_group,
                                            end_date: init.end_date,
                                            start_date: init.start_date,
                                            modification_name: init.modification_name,
                                            modification_type: init.modification_type,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateTest_1_startField */7 :
                  var nextInput$7 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$7 = {
                    contents: state.fieldsStatuses
                  };
                  var result$29 = Formality.validateDependentFieldOnChange(nextInput$7, nextFieldsStatuses$7.contents.test_1_end, validators_test_1_end, (function (status) {
                          var init = nextFieldsStatuses$7.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: status,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$29 !== undefined) {
                    nextFieldsStatuses$7.contents = result$29;
                  }
                  var result$30 = Formality.validateDependentFieldOnChange(nextInput$7, nextFieldsStatuses$7.contents.test_group, validators_test_group, (function (status) {
                          var init = nextFieldsStatuses$7.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: status,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$30 !== undefined) {
                    nextFieldsStatuses$7.contents = result$30;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$7,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$7, nextFieldsStatuses$7.contents.test_1_start, state.submissionStatus, validators_test_1_start, (function (status) {
                                    var init = nextFieldsStatuses$7.contents;
                                    return {
                                            test_4_end: init.test_4_end,
                                            test_4_start: init.test_4_start,
                                            test_3_end: init.test_3_end,
                                            test_3_start: init.test_3_start,
                                            test_2_end: init.test_2_end,
                                            test_2_start: init.test_2_start,
                                            test_1_end: init.test_1_end,
                                            test_1_start: status,
                                            test_group: init.test_group,
                                            end_date: init.end_date,
                                            start_date: init.start_date,
                                            modification_name: init.modification_name,
                                            modification_type: init.modification_type,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateTest_groupField */8 :
                  var nextInput$8 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$8 = {
                    contents: state.fieldsStatuses
                  };
                  var result$31 = Formality.validateDependentFieldOnChange(nextInput$8, nextFieldsStatuses$8.contents.test_1_start, validators_test_1_start, (function (status) {
                          var init = nextFieldsStatuses$8.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: status,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$31 !== undefined) {
                    nextFieldsStatuses$8.contents = result$31;
                  }
                  var result$32 = Formality.validateDependentFieldOnChange(nextInput$8, nextFieldsStatuses$8.contents.test_2_start, validators_test_2_start, (function (status) {
                          var init = nextFieldsStatuses$8.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: status,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$32 !== undefined) {
                    nextFieldsStatuses$8.contents = result$32;
                  }
                  var result$33 = Formality.validateDependentFieldOnChange(nextInput$8, nextFieldsStatuses$8.contents.test_3_start, validators_test_3_start, (function (status) {
                          var init = nextFieldsStatuses$8.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: status,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$33 !== undefined) {
                    nextFieldsStatuses$8.contents = result$33;
                  }
                  var result$34 = Formality.validateDependentFieldOnChange(nextInput$8, nextFieldsStatuses$8.contents.test_4_start, validators_test_4_start, (function (status) {
                          var init = nextFieldsStatuses$8.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: status,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$34 !== undefined) {
                    nextFieldsStatuses$8.contents = result$34;
                  }
                  var result$35 = Formality.validateDependentFieldOnChange(nextInput$8, nextFieldsStatuses$8.contents.test_1_end, validators_test_1_end, (function (status) {
                          var init = nextFieldsStatuses$8.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: status,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$35 !== undefined) {
                    nextFieldsStatuses$8.contents = result$35;
                  }
                  var result$36 = Formality.validateDependentFieldOnChange(nextInput$8, nextFieldsStatuses$8.contents.test_2_end, validators_test_2_end, (function (status) {
                          var init = nextFieldsStatuses$8.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: status,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$36 !== undefined) {
                    nextFieldsStatuses$8.contents = result$36;
                  }
                  var result$37 = Formality.validateDependentFieldOnChange(nextInput$8, nextFieldsStatuses$8.contents.test_3_end, validators_test_3_end, (function (status) {
                          var init = nextFieldsStatuses$8.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: status,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$37 !== undefined) {
                    nextFieldsStatuses$8.contents = result$37;
                  }
                  var result$38 = Formality.validateDependentFieldOnChange(nextInput$8, nextFieldsStatuses$8.contents.test_4_end, validators_test_4_end, (function (status) {
                          var init = nextFieldsStatuses$8.contents;
                          return {
                                  test_4_end: status,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: init.end_date,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$38 !== undefined) {
                    nextFieldsStatuses$8.contents = result$38;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$8,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$8, nextFieldsStatuses$8.contents.test_group, state.submissionStatus, validators_test_group, (function (status) {
                                    var init = nextFieldsStatuses$8.contents;
                                    return {
                                            test_4_end: init.test_4_end,
                                            test_4_start: init.test_4_start,
                                            test_3_end: init.test_3_end,
                                            test_3_start: init.test_3_start,
                                            test_2_end: init.test_2_end,
                                            test_2_start: init.test_2_start,
                                            test_1_end: init.test_1_end,
                                            test_1_start: init.test_1_start,
                                            test_group: status,
                                            end_date: init.end_date,
                                            start_date: init.start_date,
                                            modification_name: init.modification_name,
                                            modification_type: init.modification_type,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateEnd_dateField */9 :
                  var nextInput$9 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$9,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$9, state.fieldsStatuses.end_date, state.submissionStatus, validators_end_date, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            test_4_end: init.test_4_end,
                                            test_4_start: init.test_4_start,
                                            test_3_end: init.test_3_end,
                                            test_3_start: init.test_3_start,
                                            test_2_end: init.test_2_end,
                                            test_2_start: init.test_2_start,
                                            test_1_end: init.test_1_end,
                                            test_1_start: init.test_1_start,
                                            test_group: init.test_group,
                                            end_date: status,
                                            start_date: init.start_date,
                                            modification_name: init.modification_name,
                                            modification_type: init.modification_type,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateStart_dateField */10 :
                  var nextInput$10 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$9 = {
                    contents: state.fieldsStatuses
                  };
                  var result$39 = Formality.validateDependentFieldOnChange(nextInput$10, nextFieldsStatuses$9.contents.end_date, validators_end_date, (function (status) {
                          var init = nextFieldsStatuses$9.contents;
                          return {
                                  test_4_end: init.test_4_end,
                                  test_4_start: init.test_4_start,
                                  test_3_end: init.test_3_end,
                                  test_3_start: init.test_3_start,
                                  test_2_end: init.test_2_end,
                                  test_2_start: init.test_2_start,
                                  test_1_end: init.test_1_end,
                                  test_1_start: init.test_1_start,
                                  test_group: init.test_group,
                                  end_date: status,
                                  start_date: init.start_date,
                                  modification_name: init.modification_name,
                                  modification_type: init.modification_type,
                                  vehicle: init.vehicle,
                                  region: init.region
                                };
                        }));
                  if (result$39 !== undefined) {
                    nextFieldsStatuses$9.contents = result$39;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$10,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$10, nextFieldsStatuses$9.contents.start_date, state.submissionStatus, validators_start_date, (function (status) {
                                    var init = nextFieldsStatuses$9.contents;
                                    return {
                                            test_4_end: init.test_4_end,
                                            test_4_start: init.test_4_start,
                                            test_3_end: init.test_3_end,
                                            test_3_start: init.test_3_start,
                                            test_2_end: init.test_2_end,
                                            test_2_start: init.test_2_start,
                                            test_1_end: init.test_1_end,
                                            test_1_start: init.test_1_start,
                                            test_group: init.test_group,
                                            end_date: init.end_date,
                                            start_date: status,
                                            modification_name: init.modification_name,
                                            modification_type: init.modification_type,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateModification_nameField */11 :
                  var nextInput$11 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$11,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$11, state.fieldsStatuses.modification_name, state.submissionStatus, validators_modification_name, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            test_4_end: init.test_4_end,
                                            test_4_start: init.test_4_start,
                                            test_3_end: init.test_3_end,
                                            test_3_start: init.test_3_start,
                                            test_2_end: init.test_2_end,
                                            test_2_start: init.test_2_start,
                                            test_1_end: init.test_1_end,
                                            test_1_start: init.test_1_start,
                                            test_group: init.test_group,
                                            end_date: init.end_date,
                                            start_date: init.start_date,
                                            modification_name: status,
                                            modification_type: init.modification_type,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateModification_typeField */12 :
                  var nextInput$12 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$12,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$12.modification_type, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            test_4_end: init.test_4_end,
                                            test_4_start: init.test_4_start,
                                            test_3_end: init.test_3_end,
                                            test_3_start: init.test_3_start,
                                            test_2_end: init.test_2_end,
                                            test_2_start: init.test_2_start,
                                            test_1_end: init.test_1_end,
                                            test_1_start: init.test_1_start,
                                            test_group: init.test_group,
                                            end_date: init.end_date,
                                            start_date: init.start_date,
                                            modification_name: init.modification_name,
                                            modification_type: status,
                                            vehicle: init.vehicle,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateVehicleField */13 :
                  var nextInput$13 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$13,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$13.vehicle, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            test_4_end: init.test_4_end,
                                            test_4_start: init.test_4_start,
                                            test_3_end: init.test_3_end,
                                            test_3_start: init.test_3_start,
                                            test_2_end: init.test_2_end,
                                            test_2_start: init.test_2_start,
                                            test_1_end: init.test_1_end,
                                            test_1_start: init.test_1_start,
                                            test_group: init.test_group,
                                            end_date: init.end_date,
                                            start_date: init.start_date,
                                            modification_name: init.modification_name,
                                            modification_type: init.modification_type,
                                            vehicle: status,
                                            region: init.region
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateRegionField */14 :
                  var nextInput$14 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$14,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$14.region, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            test_4_end: init.test_4_end,
                                            test_4_start: init.test_4_start,
                                            test_3_end: init.test_3_end,
                                            test_3_start: init.test_3_start,
                                            test_2_end: init.test_2_end,
                                            test_2_start: init.test_2_start,
                                            test_1_end: init.test_1_end,
                                            test_1_start: init.test_1_start,
                                            test_group: init.test_group,
                                            end_date: init.end_date,
                                            start_date: init.start_date,
                                            modification_name: init.modification_name,
                                            modification_type: init.modification_type,
                                            vehicle: init.vehicle,
                                            region: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */15 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */16 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */17 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateTest_4_end: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTest_4_endField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateTest_4_start: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTest_4_startField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateTest_3_end: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTest_3_endField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateTest_3_start: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTest_3_startField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateTest_2_end: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTest_2_endField */4,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateTest_2_start: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTest_2_startField */5,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateTest_1_end: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTest_1_endField */6,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateTest_1_start: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTest_1_startField */7,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateTest_group: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTest_groupField */8,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateEnd_date: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateEnd_dateField */9,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateStart_date: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateStart_dateField */10,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateModification_name: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateModification_nameField */11,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateModification_type: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateModification_typeField */12,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateVehicle: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateVehicleField */13,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateRegion: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateRegionField */14,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurTest_4_end: (function (param) {
              return Curry._1(dispatch, /* BlurTest_4_endField */0);
            }),
          blurTest_4_start: (function (param) {
              return Curry._1(dispatch, /* BlurTest_4_startField */1);
            }),
          blurTest_3_end: (function (param) {
              return Curry._1(dispatch, /* BlurTest_3_endField */2);
            }),
          blurTest_3_start: (function (param) {
              return Curry._1(dispatch, /* BlurTest_3_startField */3);
            }),
          blurTest_2_end: (function (param) {
              return Curry._1(dispatch, /* BlurTest_2_endField */4);
            }),
          blurTest_2_start: (function (param) {
              return Curry._1(dispatch, /* BlurTest_2_startField */5);
            }),
          blurTest_1_end: (function (param) {
              return Curry._1(dispatch, /* BlurTest_1_endField */6);
            }),
          blurTest_1_start: (function (param) {
              return Curry._1(dispatch, /* BlurTest_1_startField */7);
            }),
          blurTest_group: (function (param) {
              return Curry._1(dispatch, /* BlurTest_groupField */8);
            }),
          blurEnd_date: (function (param) {
              return Curry._1(dispatch, /* BlurEnd_dateField */9);
            }),
          blurStart_date: (function (param) {
              return Curry._1(dispatch, /* BlurStart_dateField */10);
            }),
          blurModification_name: (function (param) {
              return Curry._1(dispatch, /* BlurModification_nameField */11);
            }),
          blurModification_type: (function (param) {
              return Curry._1(dispatch, /* BlurModification_typeField */12);
            }),
          blurVehicle: (function (param) {
              return Curry._1(dispatch, /* BlurVehicleField */13);
            }),
          blurRegion: (function (param) {
              return Curry._1(dispatch, /* BlurRegionField */14);
            }),
          test_4_endResult: Formality.exposeFieldResult(state.fieldsStatuses.test_4_end),
          test_4_startResult: Formality.exposeFieldResult(state.fieldsStatuses.test_4_start),
          test_3_endResult: Formality.exposeFieldResult(state.fieldsStatuses.test_3_end),
          test_3_startResult: Formality.exposeFieldResult(state.fieldsStatuses.test_3_start),
          test_2_endResult: Formality.exposeFieldResult(state.fieldsStatuses.test_2_end),
          test_2_startResult: Formality.exposeFieldResult(state.fieldsStatuses.test_2_start),
          test_1_endResult: Formality.exposeFieldResult(state.fieldsStatuses.test_1_end),
          test_1_startResult: Formality.exposeFieldResult(state.fieldsStatuses.test_1_start),
          test_groupResult: Formality.exposeFieldResult(state.fieldsStatuses.test_group),
          end_dateResult: Formality.exposeFieldResult(state.fieldsStatuses.end_date),
          start_dateResult: Formality.exposeFieldResult(state.fieldsStatuses.start_date),
          modification_nameResult: Formality.exposeFieldResult(state.fieldsStatuses.modification_name),
          modification_typeResult: Formality.exposeFieldResult(state.fieldsStatuses.modification_type),
          vehicleResult: Formality.exposeFieldResult(state.fieldsStatuses.vehicle),
          regionResult: Formality.exposeFieldResult(state.fieldsStatuses.region),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              var exit = 0;
              if (match.test_4_end || match.test_4_start || match.test_3_end || match.test_3_start || match.test_2_end || match.test_2_start || match.test_1_end || match.test_1_start || match.test_group || match.end_date || match.start_date || match.modification_name || match.modification_type || match.vehicle) {
                exit = 1;
              } else {
                if (!match.region) {
                  return false;
                }
                exit = 1;
              }
              if (exit === 1) {
                var exit$1 = 0;
                exit$1 = 2;
                if (exit$1 === 2) {
                  var exit$2 = 0;
                  exit$2 = 3;
                  if (exit$2 === 3) {
                    var exit$3 = 0;
                    exit$3 = 4;
                    if (exit$3 === 4) {
                      return true;
                    }
                    
                  }
                  
                }
                
              }
              
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */15);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */16);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */17);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */17,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */18);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function test_groups(param) {
  return {
          hd: {
            key: "1",
            value: "1",
            text: "1"
          },
          tl: {
            hd: {
              key: "2",
              value: "2",
              text: "2"
            },
            tl: {
              hd: {
                key: "3",
                value: "3",
                text: "3"
              },
              tl: {
                hd: {
                  key: "4",
                  value: "4",
                  text: "4"
                },
                tl: /* [] */0
              }
            }
          }
        };
}

function getSelectedTestGroup(value) {
  return SelectComponent$Catalyst.getSelectedItem(value, test_groups(undefined));
}

function getInitialState(key_details, region, vehicle, modification_type) {
  if (key_details !== undefined) {
    return {
            region: region,
            vehicle: vehicle,
            modification_type: modification_type,
            modification_name: key_details.name,
            start_date: Caml_option.some(key_details.start_date),
            end_date: key_details.end_date,
            test_group: SelectComponent$Catalyst.getSelectedItem(key_details.test_group, test_groups(undefined)),
            test_1_start: Belt_Array.getExn(key_details.test_ids, 0).start,
            test_1_end: Belt_Array.getExn(key_details.test_ids, 0).end,
            test_2_start: Belt_Array.getExn(key_details.test_ids, 1).start,
            test_2_end: Belt_Array.getExn(key_details.test_ids, 1).end,
            test_3_start: Belt_Array.getExn(key_details.test_ids, 2).start,
            test_3_end: Belt_Array.getExn(key_details.test_ids, 2).end,
            test_4_start: Belt_Array.getExn(key_details.test_ids, 3).start,
            test_4_end: Belt_Array.getExn(key_details.test_ids, 3).end
          };
  } else {
    return {
            region: region,
            vehicle: vehicle,
            modification_type: modification_type,
            modification_name: "",
            start_date: undefined,
            end_date: undefined,
            test_group: {
              key: "1",
              value: "1",
              text: "1"
            },
            test_1_start: undefined,
            test_1_end: undefined,
            test_2_start: undefined,
            test_2_end: undefined,
            test_3_start: undefined,
            test_3_end: undefined,
            test_4_start: undefined,
            test_4_end: undefined
          };
  }
}

function AbModificationKeyDetailsForm(Props) {
  var key_details = Props.key_details;
  var core_pricing_start_date = Props.core_pricing_start_date;
  var modification_type = Props.modification_type;
  var onNext = Props.onNext;
  var onBack = Props.onBack;
  var match = CorePricingContext.useContext(undefined);
  var vehicle_name = match.vehicle_type.vehicle_name;
  var geo_region_name = match.geo_region.geo_region_name;
  var formIdToIdType = function (start, end) {
    return {
            start: Belt_Option.getWithDefault(start, ""),
            end: Belt_Option.getWithDefault(end, "")
          };
  };
  var form = useForm(getInitialState(key_details, geo_region_name, vehicle_name, modification_type), (function (output, param) {
          return Curry._1(onNext, {
                      region: geo_region_name,
                      vehicle: vehicle_name,
                      modification_type: output.modification_type,
                      name: output.modification_name,
                      start_date: output.start_date,
                      end_date: output.end_date,
                      test_group: output.test_group,
                      test_ids: [
                        formIdToIdType(output.test_1_start, output.test_1_end),
                        formIdToIdType(output.test_2_start, output.test_2_end),
                        formIdToIdType(output.test_3_start, output.test_3_end),
                        formIdToIdType(output.test_4_start, output.test_4_end)
                      ]
                    });
        }));
  var data = form.test_groupResult;
  var tmp;
  tmp = data !== undefined ? (
      data.TAG === /* Ok */0 ? React.createElement("label", {
              className: "no-error-in-combined-validation"
            }, "(Sum of test group ID's should be less than 100%)") : React.createElement("label", {
              className: "error-in-combined-validation"
            }, "(" + data._0 + ")")
    ) : React.createElement("label", {
          className: "no-error-in-combined-validation"
        }, "(Sum of test group ID's should be less than 100%)");
  var select = form.input.test_group;
  var select$1 = form.input.test_group;
  var select$2 = form.input.test_group;
  var select$3 = form.input.test_group;
  return React.createElement(React.Fragment, undefined, React.createElement(ModalBody.make, {
                  className: "c-key-details-form",
                  children: null
                }, React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Geolocation"), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function (_event) {
                                  
                                }), true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "non-error-input", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: form.input.region
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Vehicle ID"), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function (_event) {
                                  
                                }), true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "non-error-input", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: form.input.vehicle
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Modification Type"), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function (_event) {
                                  
                                }), true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "non-error-input", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: CampaignModificationType.to_string(form.input.modification_type)
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Modification Name"), React.createElement(FormTextInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  return Curry._2(form.updateModification_name, (function (input, value) {
                                                return {
                                                        region: input.region,
                                                        vehicle: input.vehicle,
                                                        modification_type: input.modification_type,
                                                        modification_name: value,
                                                        start_date: input.start_date,
                                                        end_date: input.end_date,
                                                        test_group: input.test_group,
                                                        test_1_start: input.test_1_start,
                                                        test_1_end: input.test_1_end,
                                                        test_2_start: input.test_2_start,
                                                        test_2_end: input.test_2_end,
                                                        test_3_start: input.test_3_start,
                                                        test_3_end: input.test_3_end,
                                                        test_4_start: input.test_4_start,
                                                        test_4_end: input.test_4_end
                                                      };
                                              }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.modification_nameResult, undefined, undefined, undefined, {
                                TAG: /* Text */0,
                                _0: "Campaign Names cannot be more than 60 characters"
                              }, undefined, undefined, undefined, undefined, undefined),
                          textinput_props: {
                            value: form.input.modification_name
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Start Date"), React.createElement(FomDateInputTs$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function (param) {
                                  
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.start_dateResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          date_props: FomDateInputTs$Catalyst.make_props(form.input.start_date, Caml_option.some(Timestamp$Catalyst.isAfter(core_pricing_start_date, Timestamp$Catalyst.tomorrow(undefined)) ? core_pricing_start_date : Timestamp$Catalyst.tomorrow(undefined)), Caml_option.some(Timestamp$Catalyst.getDateTimeAfterElapsedTime(180.0, /* Days */4, Timestamp$Catalyst.tomorrow(undefined))), (function (date) {
                                  return Curry._2(form.updateStart_date, (function (input, value) {
                                                return {
                                                        region: input.region,
                                                        vehicle: input.vehicle,
                                                        modification_type: input.modification_type,
                                                        modification_name: input.modification_name,
                                                        start_date: value,
                                                        end_date: input.end_date,
                                                        test_group: input.test_group,
                                                        test_1_start: input.test_1_start,
                                                        test_1_end: input.test_1_end,
                                                        test_2_start: input.test_2_start,
                                                        test_2_end: input.test_2_end,
                                                        test_3_start: input.test_3_start,
                                                        test_3_end: input.test_3_end,
                                                        test_4_start: input.test_4_start,
                                                        test_4_end: input.test_4_end
                                                      };
                                              }), Caml_option.some(date));
                                }), "DD/MM/YYYY", undefined, undefined, undefined, undefined)
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement(LabelUnit$Catalyst.make, {
                          label: "End Date",
                          unit: "optional"
                        }), React.createElement(FomDateInputTs$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function (param) {
                                  
                                }), undefined, undefined, undefined, undefined, undefined, undefined, form.end_dateResult, undefined, undefined, undefined, modification_type === /* AB */0 ? ({
                                    TAG: /* Text */0,
                                    _0: "Experiment will auto-expire after a max duration of 4 months"
                                  }) : ({
                                    TAG: /* Text */0,
                                    _0: ""
                                  }), undefined, undefined, undefined, undefined, undefined),
                          date_props: FomDateInputTs$Catalyst.make_props(form.input.end_date, form.input.start_date, Caml_option.some(Timestamp$Catalyst.getDateTimeAfterElapsedTime(180.0, /* Days */4, Timestamp$Catalyst.tomorrow(undefined))), (function (date) {
                                  return Curry._2(form.updateEnd_date, (function (input, value) {
                                                return {
                                                        region: input.region,
                                                        vehicle: input.vehicle,
                                                        modification_type: input.modification_type,
                                                        modification_name: input.modification_name,
                                                        start_date: input.start_date,
                                                        end_date: value,
                                                        test_group: input.test_group,
                                                        test_1_start: input.test_1_start,
                                                        test_1_end: input.test_1_end,
                                                        test_2_start: input.test_2_start,
                                                        test_2_end: input.test_2_end,
                                                        test_3_start: input.test_3_start,
                                                        test_3_end: input.test_3_end,
                                                        test_4_start: input.test_4_start,
                                                        test_4_end: input.test_4_end
                                                      };
                                              }), Caml_option.some(date));
                                }), "DD/MM/YYYY", undefined, undefined, undefined, undefined)
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("div", {
                          className: "label"
                        }, "Test Group"), React.createElement(FormSelectInput$Catalyst.make, {
                          input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                  var value = FormHelper$Catalyst.TargetEventWrapper.value($$event);
                                  return Curry._2(form.updateTest_group, (function (input, value) {
                                                return {
                                                        region: input.region,
                                                        vehicle: input.vehicle,
                                                        modification_type: input.modification_type,
                                                        modification_name: input.modification_name,
                                                        start_date: input.start_date,
                                                        end_date: input.end_date,
                                                        test_group: value,
                                                        test_1_start: input.test_1_start,
                                                        test_1_end: input.test_1_end,
                                                        test_2_start: input.test_2_start,
                                                        test_2_end: input.test_2_end,
                                                        test_3_start: input.test_3_start,
                                                        test_3_end: input.test_3_end,
                                                        test_4_start: input.test_4_start,
                                                        test_4_end: input.test_4_end
                                                      };
                                              }), SelectComponent$Catalyst.getSelectedItem(value, test_groups(undefined)));
                                }), false, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                          select_props: {
                            value: form.input.test_group,
                            items: test_groups(undefined),
                            isNoneRequired: false
                          }
                        })), React.createElement(Row$Catalyst.make, {
                      children: React.createElement("div", {
                            className: "test-group-combine-validation"
                          }, React.createElement("label", {
                                className: "test-group-validation-label"
                              }, "Validations  "), tmp)
                    }), React.createElement(Row$Catalyst.make, {
                      children: select !== undefined && Caml_format.caml_int_of_string(select.value) >= 1 ? React.createElement("div", {
                              className: "test-input-ids-container"
                            }, React.createElement("div", {
                                  className: "test-group-id"
                                }, "TEST GROUP - 1"), React.createElement("div", {
                                  className: "customer-ids-input-container"
                                }, React.createElement("div", {
                                      className: "label"
                                    }, "Test IDs"), React.createElement(AbModificationKeyDetailsForm$TestIdRangeInput, {
                                      startId: form.input.test_1_start,
                                      endId: form.input.test_1_end,
                                      label: null,
                                      changeStartId: (function (newId) {
                                          var val = ModificationFormHelper.removeNonNumericValue(newId);
                                          var match = newId.length;
                                          var value = match !== 0 ? val : undefined;
                                          return Curry._2(form.updateTest_1_start, (function (input, param) {
                                                        return {
                                                                region: input.region,
                                                                vehicle: input.vehicle,
                                                                modification_type: input.modification_type,
                                                                modification_name: input.modification_name,
                                                                start_date: input.start_date,
                                                                end_date: input.end_date,
                                                                test_group: input.test_group,
                                                                test_1_start: value,
                                                                test_1_end: input.test_1_end,
                                                                test_2_start: input.test_2_start,
                                                                test_2_end: input.test_2_end,
                                                                test_3_start: input.test_3_start,
                                                                test_3_end: input.test_3_end,
                                                                test_4_start: input.test_4_start,
                                                                test_4_end: input.test_4_end
                                                              };
                                                      }), value);
                                        }),
                                      changeEndId: (function (newId) {
                                          var val = ModificationFormHelper.removeNonNumericValue(newId);
                                          return Curry._2(form.updateTest_1_end, (function (input, param) {
                                                        return {
                                                                region: input.region,
                                                                vehicle: input.vehicle,
                                                                modification_type: input.modification_type,
                                                                modification_name: input.modification_name,
                                                                start_date: input.start_date,
                                                                end_date: input.end_date,
                                                                test_group: input.test_group,
                                                                test_1_start: input.test_1_start,
                                                                test_1_end: val,
                                                                test_2_start: input.test_2_start,
                                                                test_2_end: input.test_2_end,
                                                                test_3_start: input.test_3_start,
                                                                test_3_end: input.test_3_end,
                                                                test_4_start: input.test_4_start,
                                                                test_4_end: input.test_4_end
                                                              };
                                                      }), val);
                                        }),
                                      result1: form.test_1_startResult,
                                      result2: form.test_1_endResult
                                    }))) : null
                    }), React.createElement(Row$Catalyst.make, {
                      children: select$1 !== undefined && Caml_format.caml_int_of_string(select$1.value) >= 2 ? React.createElement("div", {
                              className: "test-input-ids-container"
                            }, React.createElement("div", {
                                  className: "test-group-id"
                                }, "TEST GROUP - 2"), React.createElement("div", {
                                  className: "customer-ids-input-container"
                                }, React.createElement("div", {
                                      className: "label"
                                    }, "Test IDs"), React.createElement(AbModificationKeyDetailsForm$TestIdRangeInput, {
                                      startId: form.input.test_2_start,
                                      endId: form.input.test_2_end,
                                      label: null,
                                      changeStartId: (function (newId) {
                                          var val = ModificationFormHelper.removeNonNumericValue(newId);
                                          var match = newId.length;
                                          var value = match !== 0 ? val : undefined;
                                          return Curry._2(form.updateTest_2_start, (function (input, param) {
                                                        return {
                                                                region: input.region,
                                                                vehicle: input.vehicle,
                                                                modification_type: input.modification_type,
                                                                modification_name: input.modification_name,
                                                                start_date: input.start_date,
                                                                end_date: input.end_date,
                                                                test_group: input.test_group,
                                                                test_1_start: input.test_1_start,
                                                                test_1_end: input.test_1_end,
                                                                test_2_start: value,
                                                                test_2_end: input.test_2_end,
                                                                test_3_start: input.test_3_start,
                                                                test_3_end: input.test_3_end,
                                                                test_4_start: input.test_4_start,
                                                                test_4_end: input.test_4_end
                                                              };
                                                      }), value);
                                        }),
                                      changeEndId: (function (newId) {
                                          var val = ModificationFormHelper.removeNonNumericValue(newId);
                                          return Curry._2(form.updateTest_2_end, (function (input, param) {
                                                        return {
                                                                region: input.region,
                                                                vehicle: input.vehicle,
                                                                modification_type: input.modification_type,
                                                                modification_name: input.modification_name,
                                                                start_date: input.start_date,
                                                                end_date: input.end_date,
                                                                test_group: input.test_group,
                                                                test_1_start: input.test_1_start,
                                                                test_1_end: input.test_1_end,
                                                                test_2_start: input.test_2_start,
                                                                test_2_end: val,
                                                                test_3_start: input.test_3_start,
                                                                test_3_end: input.test_3_end,
                                                                test_4_start: input.test_4_start,
                                                                test_4_end: input.test_4_end
                                                              };
                                                      }), val);
                                        }),
                                      result1: form.test_2_startResult,
                                      result2: form.test_2_endResult
                                    }))) : null
                    }), React.createElement(Row$Catalyst.make, {
                      children: select$2 !== undefined && Caml_format.caml_int_of_string(select$2.value) >= 3 ? React.createElement("div", {
                              className: "test-input-ids-container"
                            }, React.createElement("div", {
                                  className: "test-group-id"
                                }, "TEST GROUP - 3"), React.createElement("div", {
                                  className: "customer-ids-input-container"
                                }, React.createElement("div", {
                                      className: "label"
                                    }, "Test IDs"), React.createElement(AbModificationKeyDetailsForm$TestIdRangeInput, {
                                      startId: form.input.test_3_start,
                                      endId: form.input.test_3_end,
                                      label: null,
                                      changeStartId: (function (newId) {
                                          var val = ModificationFormHelper.removeNonNumericValue(newId);
                                          var match = newId.length;
                                          var value = match !== 0 ? val : undefined;
                                          return Curry._2(form.updateTest_3_start, (function (input, param) {
                                                        return {
                                                                region: input.region,
                                                                vehicle: input.vehicle,
                                                                modification_type: input.modification_type,
                                                                modification_name: input.modification_name,
                                                                start_date: input.start_date,
                                                                end_date: input.end_date,
                                                                test_group: input.test_group,
                                                                test_1_start: input.test_1_start,
                                                                test_1_end: input.test_1_end,
                                                                test_2_start: input.test_2_start,
                                                                test_2_end: input.test_2_end,
                                                                test_3_start: value,
                                                                test_3_end: input.test_3_end,
                                                                test_4_start: input.test_4_start,
                                                                test_4_end: input.test_4_end
                                                              };
                                                      }), value);
                                        }),
                                      changeEndId: (function (newId) {
                                          var val = ModificationFormHelper.removeNonNumericValue(newId);
                                          return Curry._2(form.updateTest_3_end, (function (input, param) {
                                                        return {
                                                                region: input.region,
                                                                vehicle: input.vehicle,
                                                                modification_type: input.modification_type,
                                                                modification_name: input.modification_name,
                                                                start_date: input.start_date,
                                                                end_date: input.end_date,
                                                                test_group: input.test_group,
                                                                test_1_start: input.test_1_start,
                                                                test_1_end: input.test_1_end,
                                                                test_2_start: input.test_2_start,
                                                                test_2_end: input.test_2_end,
                                                                test_3_start: input.test_3_start,
                                                                test_3_end: val,
                                                                test_4_start: input.test_4_start,
                                                                test_4_end: input.test_4_end
                                                              };
                                                      }), val);
                                        }),
                                      result1: form.test_3_startResult,
                                      result2: form.test_3_endResult
                                    }))) : null
                    }), React.createElement(Row$Catalyst.make, {
                      children: select$3 !== undefined && Caml_format.caml_int_of_string(select$3.value) >= 4 ? React.createElement("div", {
                              className: "test-input-ids-container"
                            }, React.createElement("div", {
                                  className: "test-group-id"
                                }, "TEST GROUP - 4"), React.createElement("div", {
                                  className: "customer-ids-input-container"
                                }, React.createElement("div", {
                                      className: "label"
                                    }, "Test IDs"), React.createElement(AbModificationKeyDetailsForm$TestIdRangeInput, {
                                      startId: form.input.test_4_start,
                                      endId: form.input.test_4_end,
                                      label: null,
                                      changeStartId: (function (newId) {
                                          var val = ModificationFormHelper.removeNonNumericValue(newId);
                                          var match = newId.length;
                                          var value = match !== 0 ? val : undefined;
                                          return Curry._2(form.updateTest_4_start, (function (input, param) {
                                                        return {
                                                                region: input.region,
                                                                vehicle: input.vehicle,
                                                                modification_type: input.modification_type,
                                                                modification_name: input.modification_name,
                                                                start_date: input.start_date,
                                                                end_date: input.end_date,
                                                                test_group: input.test_group,
                                                                test_1_start: input.test_1_start,
                                                                test_1_end: input.test_1_end,
                                                                test_2_start: input.test_2_start,
                                                                test_2_end: input.test_2_end,
                                                                test_3_start: input.test_3_start,
                                                                test_3_end: input.test_3_end,
                                                                test_4_start: value,
                                                                test_4_end: input.test_4_end
                                                              };
                                                      }), value);
                                        }),
                                      changeEndId: (function (newId) {
                                          var val = ModificationFormHelper.removeNonNumericValue(newId);
                                          return Curry._2(form.updateTest_4_end, (function (input, param) {
                                                        return {
                                                                region: input.region,
                                                                vehicle: input.vehicle,
                                                                modification_type: input.modification_type,
                                                                modification_name: input.modification_name,
                                                                start_date: input.start_date,
                                                                end_date: input.end_date,
                                                                test_group: input.test_group,
                                                                test_1_start: input.test_1_start,
                                                                test_1_end: input.test_1_end,
                                                                test_2_start: input.test_2_start,
                                                                test_2_end: input.test_2_end,
                                                                test_3_start: input.test_3_start,
                                                                test_3_end: input.test_3_end,
                                                                test_4_start: input.test_4_start,
                                                                test_4_end: val
                                                              };
                                                      }), val);
                                        }),
                                      result1: form.test_4_startResult,
                                      result2: form.test_4_endResult
                                    }))) : null
                    })), React.createElement(ModalFooter.make, {
                  children: null
                }, React.createElement(PrimaryButton$Catalyst.make, {
                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                            TAG: /* Text */0,
                            _0: "Cancel"
                          }, undefined, (function (param) {
                              return Curry._1(onBack, undefined);
                            }), undefined, undefined, undefined, undefined, "c-mui-primary-back-btn", undefined, undefined)
                    }), React.createElement(PrimaryButton$Catalyst.make, {
                      buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                            TAG: /* Text */0,
                            _0: "Next"
                          }, undefined, (function (param) {
                              return Curry._1(form.submit, undefined);
                            }), undefined, undefined, undefined, undefined, "c-mui-primary-next-btn", undefined, undefined)
                    })));
}

var make = AbModificationKeyDetailsForm;

export {
  TestIdRangeInput ,
  Form ,
  test_groups ,
  getSelectedTestGroup ,
  getInitialState ,
  make ,
  
}
/* react Not a pure module */
